import React from "react";
import {Box, Button, Column, Columns, Title} from "@allxsmith/bestax-bulma";
import useInput from "../../../hooks/useInput";
import usePostRentalMargin from "../../../hooks/usePostRentalMargin";


export default function NewRentalMargin(){

    let [name, nameInput, setName] = useInput({
        type: "text",
        label: "Name"
    });

    let [margin, marginInput, setMargin] = useInput({
        type: "number",
        label: "Margin (%)",
        initialValue: 0.1,
        currency: true
    });


    const clear = () =>{
        setName("");
        setMargin(40)
    }
    const [, postMake] = usePostRentalMargin({
        name: name,
        margin: margin
    })
    const handleSubmit = () => {
        postMake().then(() => (
            clear()
        ))
    }

    return (
        <Box className="settings_type">
            <details>
                <summary><Title>Add Rental Margin</Title></summary>
            <Columns isMultiline>
                {nameInput}
                {marginInput}
            </Columns>
            <Columns isMultiline>
              <Column>
                  <Button
                      color={"success"}
                      onClick={handleSubmit}
                      isFullWidth
                  >
                      Add +
                  </Button>
              </Column>
            </Columns>
            </details>
        </Box>
    );
}